import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO/SEO';
import MainNav from '../../components/MainNav/MainNav';
import Footer from '../../components/Footer/Footer';
import './SoftwareMedidaPage.css';

const SoftwareMedidaPage = ({ darkMode, toggleDarkMode }) => {
  const beneficios = [
    {
      icon: '🎯',
      titulo: 'Adaptado 100% a tu Negocio',
      descripcion: 'El software se desarrolla según tus procesos específicos, no tienes que adaptarte a la herramienta, la herramienta se adapta a ti.'
    },
    {
      icon: '⚡',
      titulo: 'Mayor Eficiencia',
      descripcion: 'Automatiza procesos únicos de tu empresa que ningún software estándar puede cubrir, reduciendo tiempos y errores.'
    },
    {
      icon: '📈',
      titulo: 'Escalabilidad Total',
      descripcion: 'El software crece contigo. Añadimos funcionalidades según evoluciona tu negocio, sin límites ni restricciones.'
    },
    {
      icon: '🔒',
      titulo: 'Control Total',
      descripcion: 'Eres dueño del código fuente. No dependes de terceros, tienes control completo sobre tu sistema y datos.'
    },
    {
      icon: '💰',
      titulo: 'ROI Optimizado',
      descripcion: 'Inversión inicial que se amortiza rápidamente al eliminar licencias recurrentes y aumentar la productividad.'
    },
    {
      icon: '🔧',
      titulo: 'Mantenimiento y Evolución',
      descripcion: 'Soporte continuo y mejoras evolutivas. El software mejora constantemente según tus necesidades.'
    }
  ];

  const tiposSoftware = [
    {
      titulo: 'Vulpin — Gestión pymes y tercer sector',
      descripcion: 'Nuestro software propio para pymes y entidades sociales: dependencia, residencial, infancia y mujer, con módulos e integraciones.',
      caracteristicas: [
        'Expedientes y seguimiento de casos',
        'Gestión de plazas y equipos',
        'Trazabilidad y evidencias',
        'Integración con Business Central y Workspace',
        'Evolución continua del producto'
      ]
    },
    {
      titulo: 'ERP Personalizado',
      descripcion: 'Sistemas de gestión empresarial completos adaptados a procesos específicos de tu industria o modelo de negocio.',
      caracteristicas: [
        'Gestión de inventario personalizada',
        'Módulos de facturación adaptados',
        'Procesos de producción únicos',
        'Integración con maquinaria específica',
        'Reportes y dashboards personalizados'
      ]
    },
    {
      titulo: 'CRM a Medida',
      descripcion: 'Sistemas de gestión de clientes diseñados para tu proceso comercial específico y modelo de ventas.',
      caracteristicas: [
        'Pipelines de venta personalizados',
        'Automatizaciones específicas',
        'Integración con tus canales',
        'Segmentación avanzada',
        'Análisis comercial adaptado'
      ]
    },
    {
      titulo: 'Sistemas de Gestión Especializados',
      descripcion: 'Software para sectores específicos: clínicas, academias, inmobiliarias, talleres, etc.',
      caracteristicas: [
        'Funcionalidades sectoriales',
        'Workflows específicos del sector',
        'Integración con sistemas del sector',
        'Cumplimiento normativo',
        'Reportes sectoriales'
      ]
    },
    {
      titulo: 'Aplicaciones Web y Móviles',
      descripcion: 'Aplicaciones web y móviles personalizadas para procesos específicos: pedidos, reservas, gestión de campo, etc.',
      caracteristicas: [
        'Diseño responsive',
        'Apps nativas iOS/Android',
        'Funcionalidades offline',
        'Sincronización en tiempo real',
        'Interfaz intuitiva'
      ]
    }
  ];

  const proceso = [
    {
      paso: '1',
      titulo: 'Análisis y Diseño',
      descripcion: 'Analizamos tus procesos, necesidades y objetivos. Diseñamos la arquitectura y funcionalidades del software.'
    },
    {
      paso: '2',
      titulo: 'Desarrollo Iterativo',
      descripcion: 'Desarrollamos el software en sprints, mostrándote avances periódicos para validar y ajustar en tiempo real.'
    },
    {
      paso: '3',
      titulo: 'Integración y Pruebas',
      descripcion: 'Integramos con tus sistemas existentes y realizamos pruebas exhaustivas para asegurar calidad y estabilidad.'
    },
    {
      paso: '4',
      titulo: 'Despliegue y Formación',
      descripcion: 'Desplegamos el software en tu entorno y formamos a tu equipo para que aprovechen todas las funcionalidades.'
    },
    {
      paso: '5',
      titulo: 'Soporte y Evolución',
      descripcion: 'Ofrecemos soporte continuo y mejoras evolutivas para que el software crezca con tu negocio.'
    }
  ];

  const tecnologias = [
    {
      categoria: 'Frontend',
      tecnologias: ['React', 'Vue.js', 'Angular', 'Next.js', 'TypeScript']
    },
    {
      categoria: 'Backend',
      tecnologias: ['Node.js', 'Python', 'PHP', 'Java', '.NET']
    },
    {
      categoria: 'Bases de Datos',
      tecnologias: ['PostgreSQL', 'MySQL', 'MongoDB', 'SQL Server']
    },
    {
      categoria: 'Mobile',
      tecnologias: ['React Native', 'Flutter', 'Swift', 'Kotlin']
    },
    {
      categoria: 'Cloud',
      tecnologias: ['AWS', 'Azure', 'Google Cloud', 'Docker']
    }
  ];

  const sectores = [
    {
      titulo: 'Retail y Comercio',
      descripcion: 'TPV personalizados, gestión de tiendas múltiples, integración con e-commerce y sistemas de fidelización.'
    },
    {
      titulo: 'Hostelería y Restauración',
      descripcion: 'Sistemas de gestión de restaurantes, reservas, comandas, control de cocina y gestión de eventos.'
    },
    {
      titulo: 'Salud y Bienestar',
      descripcion: 'Software para clínicas, gestión de citas, historiales médicos, facturación y cumplimiento normativo.'
    },
    {
      titulo: 'Educación',
      descripcion: 'Plataformas educativas, gestión de academias, control de asistencia, evaluación y comunicación.'
    },
    {
      titulo: 'Inmobiliaria',
      descripcion: 'CRM inmobiliario, gestión de propiedades, visitas, documentación y seguimiento de clientes.'
    },
    {
      titulo: 'Logística y Transporte',
      descripcion: 'Gestión de rutas, control de flotas, tracking de envíos, optimización de entregas y facturación.'
    },
    {
      titulo: 'Manufactura',
      descripcion: 'Control de producción, gestión de materiales, calidad, mantenimiento y trazabilidad.'
    },
    {
      titulo: 'Servicios Profesionales',
      descripcion: 'Gestión de proyectos, control de tiempos, facturación por horas y gestión de recursos.'
    }
  ];

  return (
    <>
      <SEO 
        title="Software de gestión a medida para empresas | E-ASY"
        description="Software de gestión a medida para pymes y entidades: ERP, CRM y sistemas adaptados a tus procesos. Lo desarrollamos en remoto para toda España desde nuestra sede en Tenerife."
        keywords="software de gestión a medida, software personalizado, software a medida, ERP personalizado, CRM a medida, Vulpin, sistemas de gestión para empresas"
        canonical="https://e-asy.es/servicios/software-gestion-medida"
      />
      <MainNav darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <div className={`software-medida-page ${darkMode ? 'dark' : 'light'}`}>
        
        {/* Hero Section */}
        <section className="software-hero">
          <div className="software-hero-content">
            <div className="software-hero-text">
              <h1 className="software-hero-title">Software de Gestión a Medida</h1>
              <p className="software-hero-subtitle">
                E-ASY desarrolla <strong>software personalizado</strong> adaptado 100% a tu negocio. No te adaptas a la herramienta, 
                la herramienta se adapta a ti. ERP, CRM y sistemas de gestión diseñados específicamente para tus procesos.
              </p>
              <p className="software-hero-subtitle">
                Nuestro producto propio es{' '}
                <Link to="/vulpin">Vulpin Suite</Link>: software de gestión para pymes y entidades del tercer sector 
                (dependencia, residencial, infancia y mujer), con módulos e integraciones que evolucionan con tu organización.
              </p>
              <p className="software-hero-subtitle">
                Prestamos este servicio en remoto a empresas de toda <strong>España</strong> desde nuestra sede en <strong>Tenerife</strong>. También desarrollamos proyectos internacionales, con control del código y evolución continua según crece el negocio.
              </p>
              <p className="software-hero-subtitle">
                Si no es un proyecto con fecha de entrega, sino capacidad continua —un ingeniero en la empresa, por cuota mensual—, eso es{' '}
                <Link to="/servicios/ingenieria-a-cuota">ingeniería a cuota</Link> (outsourcing tecnológico).
              </p>
              <div className="software-hero-cta">
                <Link to="/contacto" className="software-hero-button primary">
                  Solicita una consultoría gratuita
                </Link>
                <Link to="/servicios" className="software-hero-button secondary">
                  Ver todos los servicios
                </Link>
              </div>
            </div>
            <div className="software-hero-visual">
              <div className="software-hero-graphic">
                <div className="code-animation">
                  <div className="code-line line-1">
                    <span className="code-keyword">function</span>
                    <span className="code-text"> gestionarEmpresa()</span>
                  </div>
                  <div className="code-line line-2">
                    <span className="code-keyword">return</span>
                    <span className="code-text"> solucionPersonalizada</span>
                  </div>
                  <div className="code-line line-3">
                    <span className="code-comment">{'// Adaptado a tu negocio'}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Qué es Section */}
        <section className="software-que-es">
          <div className="software-que-es-content">
            <div className="software-que-es-header">
              <h2 className="software-que-es-title">¿Qué es el Software a Medida?</h2>
              <p className="software-que-es-subtitle">
                El <strong>software a medida</strong> es una solución desarrollada específicamente para tu empresa, 
                adaptada a tus procesos, necesidades y objetivos. A diferencia del software estándar, no tienes que 
                cambiar tu forma de trabajar: el software se adapta a ti.
              </p>
              <p className="software-que-es-subtitle">
                Si tu empresa tiene procesos únicos, necesidades específicas del sector o requiere funcionalidades 
                que no existen en soluciones estándar, el <strong>software personalizado</strong> es la respuesta.
              </p>
            </div>
            <div className="software-comparison-table">
              <div className="comparison-header">
                <div className="comparison-header-spacer"></div>
                <div className="comparison-column-header">
                  <h3 className="comparison-header-title">Software Estándar</h3>
                  <p className="comparison-header-subtitle">Solución genérica</p>
                </div>
                <div className="comparison-column-header highlight">
                  <h3 className="comparison-header-title">Software a Medida</h3>
                  <p className="comparison-header-subtitle">Solución personalizada</p>
                </div>
              </div>
              
              <div className="comparison-row">
                <div className="comparison-aspect">
                  <span className="aspect-label">Adaptación a Procesos</span>
                </div>
                <div className="comparison-value">
                  <span className="value-text">Debes adaptar tus procesos al software. Cambios en workflows para encajar con funcionalidades predefinidas.</span>
                </div>
                <div className="comparison-value highlight">
                  <span className="value-text">El software se adapta a tus procesos. Diseñamos funcionalidades específicas para tu forma de trabajar.</span>
                </div>
              </div>

              <div className="comparison-row">
                <div className="comparison-aspect">
                  <span className="aspect-label">Funcionalidades</span>
                </div>
                <div className="comparison-value">
                  <span className="value-text">Funcionalidades genéricas para el sector. Muchas que no usas y faltan otras que necesitas específicamente.</span>
                </div>
                <div className="comparison-value highlight">
                  <span className="value-text">Solo las funcionalidades que necesitas. Desarrollamos características específicas para tu negocio.</span>
                </div>
              </div>

              <div className="comparison-row">
                <div className="comparison-aspect">
                  <span className="aspect-label">Costos</span>
                </div>
                <div className="comparison-value">
                  <span className="value-text">Licencias mensuales/anuales recurrentes. Costos que crecen con usuarios. Módulos adicionales con coste extra.</span>
                </div>
                <div className="comparison-value highlight">
                  <span className="value-text">Inversión inicial controlada. Sin costos recurrentes de licencias. Escalas pagando solo lo que necesitas.</span>
                </div>
              </div>

              <div className="comparison-row">
                <div className="comparison-aspect">
                  <span className="aspect-label">Personalización</span>
                </div>
                <div className="comparison-value">
                  <span className="value-text">Limitada a configuraciones predefinidas. Cambios complejos requieren plugins costosos o no son posibles.</span>
                </div>
                <div className="comparison-value highlight">
                  <span className="value-text">Personalización total. Cualquier cambio o nueva funcionalidad es posible. Control completo del código.</span>
                </div>
              </div>

              <div className="comparison-row">
                <div className="comparison-aspect">
                  <span className="aspect-label">Propiedad y Control</span>
                </div>
                <div className="comparison-value">
                  <span className="value-text">Dependes del proveedor. Si desaparece o cambia políticas, pierdes acceso. No tienes el código fuente.</span>
                </div>
                <div className="comparison-value highlight">
                  <span className="value-text">Eres dueño del código fuente. Control total. Puedes cambiar de proveedor o mantenerlo internamente.</span>
                </div>
              </div>

              <div className="comparison-row">
                <div className="comparison-aspect">
                  <span className="aspect-label">Integración</span>
                </div>
                <div className="comparison-value">
                  <span className="value-text">Integraciones limitadas a lo que el proveedor ofrece. APIs cerradas o con restricciones.</span>
                </div>
                <div className="comparison-value highlight">
                  <span className="value-text">Integraciones personalizadas con cualquier sistema. APIs abiertas diseñadas para tus necesidades.</span>
                </div>
              </div>

              <div className="comparison-row">
                <div className="comparison-aspect">
                  <span className="aspect-label">Escalabilidad</span>
                </div>
                <div className="comparison-value">
                  <span className="value-text">Límites según el plan contratado. Para crecer necesitas cambiar de plan o añadir módulos costosos.</span>
                </div>
                <div className="comparison-value highlight">
                  <span className="value-text">Escalabilidad sin límites. Añadimos funcionalidades según creces sin restricciones de plan.</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Beneficios Section */}
        <section className="software-beneficios">
          <div className="software-beneficios-content">
            <div className="software-beneficios-header">
              <h2 className="software-beneficios-title">Beneficios del Software a Medida</h2>
              <p className="software-beneficios-subtitle">
                Ventajas competitivas que solo el software personalizado puede ofrecer
              </p>
            </div>
            <div className="software-beneficios-grid">
              {beneficios.map((beneficio, index) => (
                <div key={index} className="software-beneficio-card">
                  <div className="beneficio-icon">{beneficio.icon}</div>
                  <h3 className="beneficio-title">{beneficio.titulo}</h3>
                  <p className="beneficio-description">{beneficio.descripcion}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Tipos de Software Section */}
        <section className="software-tipos">
          <div className="software-tipos-content">
            <div className="software-tipos-header">
              <h2 className="software-tipos-title">Tipos de Software que Desarrollamos</h2>
              <p className="software-tipos-subtitle">
                Desarrollamos diferentes tipos de software personalizado según las necesidades de tu empresa
              </p>
            </div>
            <div className="software-tipos-grid">
              {tiposSoftware.map((tipo, index) => (
                <div key={index} className="software-tipo-card">
                  <h3 className="tipo-title">{tipo.titulo}</h3>
                  <p className="tipo-description">{tipo.descripcion}</p>
                  <div className="tipo-caracteristicas">
                    <h4 className="caracteristicas-title">Características:</h4>
                    <ul className="caracteristicas-list">
                      {tipo.caracteristicas.map((caracteristica, idx) => (
                        <li key={idx} className="caracteristica-item">{caracteristica}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Proceso Section */}
        <section className="software-proceso">
          <div className="software-proceso-content">
            <div className="software-proceso-header">
              <h2 className="software-proceso-title">Nuestro Proceso de Desarrollo</h2>
              <p className="software-proceso-subtitle">
                Metodología ágil y probada que asegura el éxito de tu proyecto de software personalizado
              </p>
            </div>
            <div className="software-proceso-timeline">
              {proceso.map((item, index) => (
                <div key={index} className="proceso-step">
                  <div className="step-number">{item.paso}</div>
                  <div className="step-content">
                    <h3 className="step-title">{item.titulo}</h3>
                    <p className="step-description">{item.descripcion}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Tecnologías Section */}
        <section className="software-tecnologias">
          <div className="software-tecnologias-content">
            <div className="software-tecnologias-header">
              <h2 className="software-tecnologias-title">Tecnologías que Utilizamos</h2>
              <p className="software-tecnologias-subtitle">
                Trabajamos con las tecnologías más modernas y robustas del mercado
              </p>
            </div>
            <div className="software-tecnologias-grid">
              {tecnologias.map((categoria, index) => (
                <div key={index} className="tecnologia-categoria-card">
                  <h3 className="categoria-title">{categoria.categoria}</h3>
                  <div className="tecnologias-tags">
                    {categoria.tecnologias.map((tech, idx) => (
                      <span key={idx} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Sectores Section */}
        <section className="software-sectores">
          <div className="software-sectores-content">
            <div className="software-sectores-header">
              <h2 className="software-sectores-title">Software a Medida para Diferentes Sectores</h2>
              <p className="software-sectores-subtitle">
                Desarrollamos software personalizado adaptado a las necesidades específicas de cada sector
              </p>
            </div>
            <div className="software-sectores-grid">
              {sectores.map((sector, index) => (
                <div key={index} className="software-sector-card">
                  <h3 className="sector-title">{sector.titulo}</h3>
                  <p className="sector-description">{sector.descripcion}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="software-que-es cobertura-servicio">
          <div className="software-que-es-content">
            <div className="software-que-es-header">
              <h2 className="software-que-es-title">Software de gestión a medida en toda España</h2>
              <p className="software-que-es-subtitle">
                La oficina está en Tenerife y el trabajo de desarrollo, implantación y mantenimiento se hace en remoto con equipos de cualquier comunidad. La atención presencial se concentra en Canarias. El detalle está en{' '}
                <Link to="/donde-trabajamos">dónde trabajamos</Link>
                . Si buscas acompañamiento local, está en la página de{' '}
                <Link to="/consultoria-tecnologica-tenerife">consultoría tecnológica en Tenerife</Link>.
              </p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="software-cta">
          <div className="software-cta-content">
            <h2 className="software-cta-title">¿Necesitas Software Personalizado para tu Empresa?</h2>
            <p className="software-cta-subtitle">
              Agenda una consultoría gratuita y descubre cómo el software a medida puede transformar tu negocio
            </p>
            <div className="software-cta-buttons">
              <Link to="/contacto" className="software-cta-button primary">
                Solicita una consultoría gratuita
              </Link>
              <Link to="/servicios" className="software-cta-button secondary">
                Ver todos los servicios
              </Link>
            </div>
          </div>
        </section>

      </div>
      <Footer darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
    </>
  );
};

export default SoftwareMedidaPage;

